<h2 mat-dialog-title>{{ "demo.idleTimeout.title" | translate }}</h2>
<mat-dialog-content>
  <p>{{ "demo.idleTimeout.body" | translate }}</p>
  <p class="bold">
    {{
      "demo.idleTimeout.countdown" | translate: { seconds: remainingSeconds }
    }}
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="button primary-button" (click)="confirm()">
    {{ "demo.idleTimeout.confirm" | translate }}
  </button>
</mat-dialog-actions>
